import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div`
  min-width: 100%;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;

  ${({ theme }) => `
    border-radius: ${theme.borderRadius.base};
  `}

  ${media.sm`
    min-width: auto;
  `}
`
